module.exports = __webpack_public_path__ + "img/buren.bf631410.jpg";